import { ChipsideComponent } from "../chipside-component";

export class DropdownDivider extends ChipsideComponent {
	parsedCallback() {
		this.appendChild(document.createElementWithContents("hr", null, { className: "dropdown__divider" }));
	}
}